export default __webpack_public_path__ + "static/HelveticaNeue-Light-8958c3657af920f92d8cd90deba653d5.woff2";